import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

const BOTTOM_BAR_HEIGHT_STORAGE_KEY = 'pmw_timeline_bottom_bar_height';

const getPersistedBottomBarHeight = (): number => {
  try {
    const stored = localStorage.getItem(BOTTOM_BAR_HEIGHT_STORAGE_KEY);
    if (stored) {
      const parsed = Number(stored);
      if (!isNaN(parsed) && parsed >= 135 && parsed <= 600) {
        return parsed;
      }
    }
  } catch {
    // localStorage may be unavailable
  }
  return 220;
};

export const persistBottomBarHeight = (height: number): void => {
  try {
    localStorage.setItem(BOTTOM_BAR_HEIGHT_STORAGE_KEY, String(height));
  } catch {
    // localStorage may be unavailable
  }
};

interface State {
  bottomBarHeight?: number;
  mobileTimelineHeight?: number;
}

const initialState: State = {
  bottomBarHeight: getPersistedBottomBarHeight(),
  mobileTimelineHeight: 220,
};

export const posterEditorWebBottomBarSlice = createSlice({
  name: 'posterEditorWebBottomBar',
  initialState,
  reducers: {
    updateTimelineBottomBarHeight: (state, action: PayloadAction<number>): void => {
      state.bottomBarHeight = action.payload;
    },
    updateMobileTimelineHeight: (state, action: PayloadAction<number>): void => {
      state.mobileTimelineHeight = action.payload;
    },
  },
});

export const {updateTimelineBottomBarHeight, updateMobileTimelineHeight} = posterEditorWebBottomBarSlice.actions;

export const posterEditorWebBottomBarReducer = posterEditorWebBottomBarSlice.reducer;
